import React, { useState, useRef } from 'react'

import AudioPlayer from './AudioPlayer';
import Popup from '../partials/OLIPopup';

function NavBar(props) {
    const [audioURL, setAudioURL] = useState('');
    const [selectedButton, setSelectedButton] = useState(null);
    const [popupData, setPopupData] = useState(null);
    const popupType = useRef(null);

    const handleClick = (type,id) => {
        if (type === 'overview' || type === 'resources') {
            openPopup(type);
            setSelectedButton(id);
        }
        if (type === 'menu') {
            closePopup();
            props.goToMenu();
        }
        if (type === 'exit') {
            if(props.moduleIndex === 5) { //Module index can change if the course content get updated
                exitCourse();
            } else {
                openPopup(type);
                setSelectedButton(id);
            }
        }
        popupType.current = type;
    }

    const openPopup = buttonType => {
        setPopupData(props.data.popups[buttonType]);
    }

    const closePopup = () => {
        setSelectedButton(null);
        setPopupData(null);
    }

    const exitCourse = () => {
        // only works in LMS (not in dev environment/allen client site)
        // TODO: plug in SCORM exit functions
        window.top.close();
    }

    return (
        <div className={`NavBar`}>
            <div className={`logo`} />
            <div className={`logo_title`} />

            <div className={`buttons-container`}>
                {
                    props.data.buttons.map((e,i) => {
                        return <div className={`button ${e.type}-button ${selectedButton === i ? 'selected' : ''}`} onClick={() => handleClick(e.type, i)} key={`button-${i}`}>
                            <div className={`text`}>{e.text.toUpperCase()}</div>
                            <div className={`underline`} />
                            </div>
                    })
                }
            </div>
            {/* <AudioPlayer audioController={props.audioController} /> */}
            {popupData !== null && (
                <Popup data={popupData} onComplete={popupType.current === 'exit' ? exitCourse : closePopup} onCancel={popupType.current === 'exit' ? closePopup: undefined} />
            )}
        </div>
    )
}

export default NavBar